// App Store Links - TODO: Replace with actual URLs
export const APP_STORE_URL = '#app-store'; // TODO: Add actual App Store URL
export const GOOGLE_PLAY_URL = '#google-play'; // TODO: Add actual Google Play URL

// Social Proof Stats - TODO: Update with real metrics
export const STATS = {
  downloads: '10,000+',
  rating: '4.8',
  languages: '50+',
} as const;

// Supported Languages
export const LANGUAGES = ['English', 'French', 'German', 'Italian', 'Spanish'] as const;

// FAQ Items
export const FAQ_ITEMS = [
  {
    question: 'Is Lexifox free?',
    answer: 'Lexifox is free to download and use with core features. Premium themes and advanced features are available through in-app purchase.',
  },
  {
    question: 'What languages are available?',
    answer: 'Lexifox supports English, French, German, Italian, and Spanish vocabulary learning.',
  },
  {
    question: 'How does spaced repetition work?',
    answer: 'Spaced repetition shows you words at optimal intervals for memory retention. Words you struggle with appear more frequently, while mastered words appear less often.',
  },
  {
    question: 'Can I use it offline?',
    answer: 'Yes! Once you\'ve downloaded your word sets, you can practice completely offline. Your progress syncs when you\'re back online.',
  },
  {
    question: 'How long should I practice daily?',
    answer: 'Even 5 minutes a day can make a difference! Consistency matters more than duration. Start with a comfortable goal and build from there.',
  },
  {
    question: 'What\'s the difference between themes?',
    answer: 'Themes change the visual background of your practice sessions. Forest theme is free, while Beach and Library themes are premium features that create different learning atmospheres.',
  },
  {
    question: 'Will there be more languages?',
    answer: 'We currently support 5 languages (English, French, German, Italian, Spanish) and are actively working on adding more. Join our newsletter to get notified when new languages launch.',
  },
  {
    question: 'How do I track my progress?',
    answer: 'Lexifox tracks your daily streaks, total words learned, and mastery levels. You can view detailed statistics in the app\'s progress section.',
  },
] as const;

// Navigation Links
export const NAV_LINKS = [
  { label: 'App', path: '/#app' },
  { label: 'Features', path: '/#features' },
  { label: 'FAQ', path: '/#faq' },
] as const;

// Footer Links (includes Delete Account)
export const FOOTER_LINKS = [
  { label: 'Home', path: '/' },
  { label: 'Blog', path: '/blog' },
  { label: 'Privacy', path: '/privacy' },
  { label: 'Terms', path: '/terms' },
  { label: 'Delete Account', path: '/delete-account' },
] as const;

// Social Links - TODO: Add actual social media URLs
export const SOCIAL_LINKS = {
  twitter: '#twitter',
  instagram: '#instagram',
  facebook: '#facebook',
} as const;

// Company Info
export const COMPANY_INFO = {
  name: 'Lexifox',
  tagline: 'Expand your vocabulary, one word at a time',
  year: new Date().getFullYear(),
} as const;
